import request from '../utils/request'


export function index(params) {
  	return request({
  	  url: '/bunks',
  	  method: 'get',
        params
  	})
  }
  export function inventory(params) {
    return request({
      url: '/bunks/inventory',
      method: 'get',
      params
    })
  }

export function show(id) {
    return request({
      url: `/bunks/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/bunks',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/bunks/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/bunks/${id}`,
      method: 'delete',
    })
  }
